import { defineMessages } from 'react-intl';

export default defineMessages({
	settingsPageBreadcrumbItem: {
		defaultMessage: 'Help centers',
		description: 'Help center edit details page breadcrumb item',
		id: 'help.center.settings.breadcrumb.item',
	},
	settingsPageBreadcrumbItemHelpHub: {
		defaultMessage: 'Help centers',
		description: 'Help center edit details page breadcrumb item',
		id: 'help.hub.settings.breadcrumb.item',
	},
	breadcrumbsLabel: {
		id: 'help.center.settings.breadcrumbs.container',
		defaultMessage: 'Breadcrumbs',
		description:
			'The text is shown as the accessible label for the breadcrumb navigation wrapper in the Help Center settings area, used by screen readers to identify the breadcrumb trail.',
	},
});
